var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSimpleModal } from 'hx-ui';
export function useStyledModal(message, config) {
    return useSimpleModal(message, __assign({ modalProps: {
            sx: {
                minWidth: '70svw',
                background: "linear-gradient(to right,#FB9C84,#E499B1,#717BFF,#80D6D0)\n          left \n          bottom\n          #777    \n          no-repeat; \n          ",
                backgroundSize: '100% 6px',
                backgroundColor: 'white',
            },
        }, buttonProps: {
            className: 'mb-4 md:mb-0',
            text: 'Okay',
        } }, config));
}
